import React from 'react';
import {
	AuthenticatorBlock,
	Box,
	Button,
	ComposableTypography,
	Loader,
	RoundIcon,
	Spacer,
	Typography,
	useThemePalette,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';
import { useAuthenticatorHelper } from './authenticatorFooter.helper';
import { NavCloseO } from '@bcp-nextgen-dx-component-factory/accolade-design-system/dist/assets/MBCP/icons';
import { LEFT_PANEL_WIDTH } from '@constants';
import { Anything } from '@types';
import { Link } from '@components';

export const AuthenticatorFooter: React.FC = () => {
	const {
		resources,
		showAuthentication,
		canRequestNewCode,
		buttonDisableValidate,
		showMessageError,
		loading,
		requestAuthentication,
		onClickToNavigate,
		onButtonClick,
		onChangeValue,
		setToken,
		clearInformation,
	} = useAuthenticatorHelper();
	const { global } = useThemePalette();
	return (
		<Box
			styles={{
				position: 'fixed',
				bottom: 0,
				width: `calc(100vw - ${rem(LEFT_PANEL_WIDTH)})`,
				height: showAuthentication ? rem(185) : rem(114),
				zIndex: 100,
				background: global.ui19,
			}}
		>
			{loading && (
				<Box
					styles={{
						justifyContent: 'center',
						alignItems: 'center',
						height: '100%',
						flexGrow: 1,
						flexDirection: 'column',
					}}
				>
					<Spacer vertical={87} />
					<Loader height={100} width={100} />
				</Box>
			)}

			{!loading && showAuthentication && (
				<Box
					styles={{
						justifyContent: 'space-between',
						width: '100%',
						margin: rem(0, 80),
						paddingBottom: rem(24),
					}}
				>
					<Box
						styles={{
							paddingTop: showMessageError ? rem(28) : 0,
						}}
					>
						<AuthenticatorBlock
							title={resources.authenticationTitle}
							description={resources.description}
							mode={'sms'}
							onChange={onChangeValue}
							onSubmit={(text) => {
								setToken(text);
							}}
							errorMessage={showMessageError ? resources.errorMessage : undefined}
						/>
					</Box>
					<Box
						styles={{
							alignItems: 'center',
						}}
					>
						<Box
							styles={{
								flexDirection: 'column',
								alignItems: 'flex-end',
							}}
						>
							<Box>
								<RoundIcon
									onPress={clearInformation}
									size="medium"
									mode="custom"
									icon={{
										source: NavCloseO,
										svgProps: {
											width: rem(11),
											height: rem(11),
										},
									}}
									color="transparent"
								/>
							</Box>
							<Spacer vertical={15} />
							<Box
								styles={{
									alignItems: 'baseline',
									marginTop: rem(14),
								}}
							>
								<Box
									styles={{
										marginRight: rem(24),
										height: '100%',
									}}
								>
									{!canRequestNewCode ? (
										<ComposableTypography
											baseProps={{ appearance: 'microcopy-75-02' }}
											text={resources.message}
											tags={{
												timeBold: { appearance: 'microcopy-75-04' },
											}}
										/>
									) : (
										<Link
											onClick={() => {
												requestAuthentication();
											}}
										>
											<Typography
												appearance="microcopy-100-03"
												alternativeStyleProperties={{ color: global.ui1 } as Anything}
											>
												{resources.askAnotherCode}
											</Typography>
										</Link>
									)}
								</Box>
								<Box>
									<Button
										appearance="primary"
										size="medium"
										disabled={buttonDisableValidate}
										onPress={onButtonClick}
									>
										{resources.validateButton}
									</Button>
								</Box>
							</Box>
						</Box>
					</Box>
				</Box>
			)}
			{!loading && !showAuthentication && (
				<Box
					styles={{
						alignItems: 'center',
						justifyContent: 'space-between',
						width: '100%',
						margin: rem(0, 80),
					}}
				>
					<Box
						styles={{
							flexGrow: '10',
						}}
					>
						<Link onClick={onClickToNavigate}>
							<Typography appearance="body-100-03" colorsLevel="linkDefault">
								{resources.linkBack}
							</Typography>
						</Link>
					</Box>
					<Box
						styles={{
							alignItems: 'center',
							justifyContent: 'space-around',
							flexGrow: '1',
						}}
					>
						<Box
							styles={{
								flexDirection: 'column',
								marginBottom: rem(4),
							}}
						>
							<div>
								<Typography appearance="body-100-04">{resources.title}</Typography>
							</div>
							<div>
								<Typography appearance="microcopy-75-02">{resources.subtitle}</Typography>
							</div>
						</Box>
						<Box>
							<Button appearance="primary" onPress={requestAuthentication}>
								{resources.typeAuthenticationSMS}
							</Button>
						</Box>
					</Box>
				</Box>
			)}
		</Box>
	);
};
